export const iconFontAwesomeUsersPeopleUserClock = (
	<i className="fa-solid fa-user-clock"></i>
);
